module.exports = __webpack_public_path__ + "img/Go-Logo_LightBlue.fd8b1d12.jpg";